import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=ts&setup=true"

import "./PrivacyPolicyContent.vue?vue&type=style&index=0&id=a1051f3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1051f3a"]])

export default __exports__